// extracted by mini-css-extract-plugin
export const sectionSpacing = "button-module--section-spacing--3BnDo";
export const rowSpacing = "button-module--row-spacing--sN7v5";
export const rowSpacingSml = "button-module--row-spacing-sml--osXMC";
export const btn = "button-module--btn--OOMlO";
export const btnYellow = "button-module--btnYellow--36Mqj";
export const btnOrange = "button-module--btnOrange--2q-ex";
export const btnTurquoise = "button-module--btnTurquoise--1F5lw";
export const btnRed = "button-module--btnRed--2Yqdn";
export const btnGreen = "button-module--btnGreen--3UUSA";